'use strict';

module.exports = function (element) {
    if (element && element.closest('[data-no-scroll="true"]').length) {
        return;
    }

    var headerHeight = $('header').outerHeight() || 0;
    var orderSummaryCollapseHeight = $('.order-summary-collapse').outerHeight() || 0;
    var position = element && element.length ? (element.offset().top - headerHeight - orderSummaryCollapseHeight - 8) : 0;
    if (!element || (element && element.closest('.modal').length === 0)) {
        $('html, body').animate({
            scrollTop: position
        }, 500, function () {
            headerHeight = $('header').outerHeight() || 0;
            orderSummaryCollapseHeight = $('.order-summary-collapse').outerHeight() || 0;
            var newPosition = element && element.length ? (element.offset().top - headerHeight - orderSummaryCollapseHeight - 8) : 0;
            if (newPosition !== position) {
                $('html, body').animate({
                    scrollTop: newPosition
                });
            }
        });
    }
    if (!element) {
        $('.logo-home').focus();
    }
};
